/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentAttributesQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AIAgentAttributesQueryOperator");
    }

    getFixupPrototypeFunction() { return AIAgentAttributesQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AIAgentAttributesQueryOperator>): AIAgentAttributesQueryOperator {
        let obj = Object.assign(new AIAgentAttributesQueryOperator(), model);
        AIAgentAttributesQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentAttributesQueryOperator>): AIAgentAttributesQueryOperator {
        if (!model) return null;
        return AIAgentAttributesQueryOperator.newInstance(<AIAgentAttributesQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentAttributesQueryOperator) {
        if (!obj) return;

        models.AIAgentAttributesQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentAttributesQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AIAgentAttributesQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Span attribute key to filter by
     */
    attribute_key: string;

    /**
     * Attribute values to match
     */
    attribute_values: Array<string>;

}
